import React, { useState } from 'react';
import { EyeIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/8mc8WZ2Kayh29xRqnfAKZk/1_Maniobra-de-desobstruccion.png',
  alt: 'Maniobra de desobstrucción'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nxHoFeEWPhtgRSCJuXEZCr/3_Que-hacer-de-inmediato.png',
  alt: 'Qué hacer de inmediato'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gYiJPJL5aKKwVj84Lk7kiy/Untitled.png',
  alt: 'Plantas tóxicas frecuentes'
}];
export function GallerySection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextImage = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const prevImage = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  return <section className="bg-white py-16 px-4" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <div className="text-center mb-12" data-id="element-66">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-8" data-id="element-67">
            Así se ve el interior del manual.
          </h2>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-[#4B5563] font-medium" data-id="element-68">
            <span className="flex items-center gap-2 px-3 py-1 bg-gray-50 rounded-full" data-id="element-69">
              <EyeIcon className="w-4 h-4 text-blue-600" data-id="element-70" /> Qué hacer de
              inmediato
            </span>
            <span className="flex items-center gap-2 px-3 py-1 bg-gray-50 rounded-full" data-id="element-71">
              <EyeIcon className="w-4 h-4 text-blue-600" data-id="element-72" /> Qué NO hacer
            </span>
            <span className="flex items-center gap-2 px-3 py-1 bg-gray-50 rounded-full" data-id="element-73">
              <EyeIcon className="w-4 h-4 text-blue-600" data-id="element-74" /> Cuándo es emergencia
              crítica
            </span>
            <span className="flex items-center gap-2 px-3 py-1 bg-gray-50 rounded-full" data-id="element-75">
              <EyeIcon className="w-4 h-4 text-blue-600" data-id="element-76" /> Señales de gravedad
            </span>
          </div>
        </div>

        <div className="relative max-w-2xl mx-auto" data-id="element-77">
          {/* Carousel Container */}
          <div className="relative rounded-xl overflow-hidden shadow-2xl border border-gray-100 aspect-[4/3] bg-gray-100" data-id="element-78">
            <img src={images[currentIndex].src} alt={images[currentIndex].alt} className="w-full h-full object-contain" data-id="element-79" />

            {/* Navigation Buttons */}
            <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500" aria-label="Anterior imagen" data-id="element-80">
              <ChevronLeftIcon className="w-6 h-6" data-id="element-81" />
            </button>

            <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500" aria-label="Siguiente imagen" data-id="element-82">
              <ChevronRightIcon className="w-6 h-6" data-id="element-83" />
            </button>
          </div>

          {/* Dots Indicators */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-84">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-3 h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-blue-600 w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-85" />)}
          </div>
        </div>
      </div>
    </section>;
}